export default "__VITE_ASSET__BBl_9qHt__"